module.exports = __webpack_public_path__ + "img/1.c18c3f88.jpg";